export default __webpack_public_path__ + "star-solid-brown.412338a7.svg";